module.exports = __webpack_public_path__ + "img/discordDark.f8143334.svg";